import { useState } from 'react'

import {
  Box,
  Stack,
  StackProps,
  RadioGroup,
  FormControlLabel,
  Radio,
  useTheme,
  Divider
} from '@mui/material'

import { SearchResult } from 'interface/search'
import { MrpProjectList } from './components/mrpProjectList'
import { LvProjectList } from './components/lvProjectList'
import { SearchWordField } from 'components/controls/searchWordField'

type SearchProjectPageProps = {
  search: SearchResult
  openMrpProject: (projectId: number, isOpenGrid: boolean) => void
  openLvProject: (projectCode: string, isOpenGrid: boolean) => void
  isSmallMedia: boolean
} & StackProps
export const SearchProjectPage = ({
  search,
  openMrpProject,
  openLvProject,
  isSmallMedia,
  ...others
}: SearchProjectPageProps) => {
  const theme = useTheme()
  const [source, setSource] = useState<string | null>(null)
  const [searchWord, setSearchWord] = useState<string>('')
  return (
    <Stack {...others} direction="column">
      <Stack
        direction="row"
        paddingRight={1}
        alignItems="center"
        sx={isSmallMedia ? {
          position: 'sticky',
          top: 49,
          zIndex: 1,
          background: theme.palette.background.paper,
          borderBottom: 1,
          borderColor: theme.palette.divider
        } : undefined}
      >
        <RadioGroup
          value={source}
          onChange={(e) => setSource(e.target.value)}
          sx={{ paddingX: 2, paddingY: 1, flexShrink: 0 }}
        >
          <Stack direction='row' spacing={0}>
            <FormControlLabel value="mrp" control={<Radio />} label='MRP' />
            <FormControlLabel value="lv" control={<Radio />} label='Web講演会'/>
          </Stack>
        </RadioGroup>

        <Box flexGrow={1} />

        <SearchWordField
          id="search-word-search"
          searchWord={searchWord}
          fullWidth
          onChangeSearchWord={setSearchWord}
        />
      </Stack>

      {isSmallMedia === false && <Divider/>}

      <Box flexGrow={1} overflow="auto">
        {source === "mrp" ? (
          <MrpProjectList searchId={search?.searchId} searchWord={searchWord} openMrpProject={openMrpProject}/>
        ) : source === "lv" ? (
          <LvProjectList searchId={search?.searchId} searchWord={searchWord} openLvProject={openLvProject} />
        ) : <></>}
      </Box>
    </Stack>
  )
}
